import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PÁGINA DE SIN PERMISOS
 * 
 * Se muestra cuando un usuario intenta acceder a una ruta o módulo
 * para el cual no tiene los permisos necesarios.
 * 
 */

const SinPermisos = () => {
  const navigate = useNavigate();
  
  const handleGoHome = () => {
    navigate('/inicio');
  };
  
  return (
    <div className="min-h-screen w-full bg-black/40 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Card*/}
        <div className="bg-white rounded-lg shadow-2xl overflow-hidden animate-fade-in">
          
          {/* Contenido */}
          <div className="px-8 py-10 text-center">
            {/* Ícono de advertencia */}
            <div className="w-20 h-20 mx-auto mb-6 border-4 border-orange-400 rounded-full flex items-center justify-center">
              <span className="text-orange-400 text-6xl font-bold">!</span>
            </div>
            
            {/* Título */}
            <h1 className="text-2xl font-semibold text-gray-800 mb-4">
              Acceso Restringido
            </h1>
            
            {/* Mensaje */}
            <p className="text-gray-600 text-base mb-6 leading-relaxed">
              No tienes los permisos necesarios para acceder a este módulo o funcionalidad.
              <br />
              Por favor, contacte al administrador del sistema si cree que esto es un error.
            </p>

            {/* Botón de acción */}
            <button
              onClick={handleGoHome}
              className="w-full px-8 py-3 text-white font-medium rounded shadow-md transition-all duration-200 hover:shadow-lg"
              style={{ backgroundColor: '#CC0000' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#B00000'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#CC0000'}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SinPermisos;
